import React, { useEffect, useState } from "react";
import { db } from "./Firebase";
import "./Home.css";
import Product from "./Product";
import { useStateValue } from "./StateProvider";

const productA = {
	title:
		"Sony Bravia 164 cm (65 Inches) 4K Ultra HD Smart Android LED TV 65X7400H (Black) (2020 Model)",
	image:
		"https://images-na.ssl-images-amazon.com/images/I/71vGNco7X2L._SL1500_.jpg",
	price: "99,999.00",
	rating: "4",
};
const productB = {
	title:
		"Panasonic 147 cm (58 inches) 4K Ultra HD Certified Android Smart LED TV TH-58HX450DX (Black) (2020 Model)",
	image:
		"https://images-na.ssl-images-amazon.com/images/I/91LzCxOO3fL._SL1500_.jpg",
	price: "52,990.00",
	rating: "4",
};
const productC = {
	title: "Bagrrys Fruit N Fibre Muesli, Mixed Fruit, 500g",
	image:
		"https://images-na.ssl-images-amazon.com/images/I/81MHqYDg33L._SL1500_.jpg",
	price: "299.00",
	rating: "4",
};
const productD = {
	title:
		"Kellogg's Corn Flakes Original, High in Iron, High in B Group Vitamins, Breakfast Cereals, 875g Pack",
	image:
		"https://images-na.ssl-images-amazon.com/images/I/71HsQr-pYjL._SL1500_.jpg",
	price: "279.00",
	rating: "5",
};
const productE = {
	title: "Kellogg's Chocos Whole Grain, 375g",
	image:
		"https://images-na.ssl-images-amazon.com/images/I/61fRSMtXE6L._SL1000_.jpg",
	price: "165.00",
	rating: "4",
};
const productF = {
	title: "Samsung LC49HG90DMUXEN 48.9-inch Ultra Wide Curved Monitor (Black)",
	image:
		"https://images-na.ssl-images-amazon.com/images/I/71MlcO29QOL._SL1500_.jpg",
	price: "1,99,990.00",
	rating: "4",
};
const productG = {
	title:
		"New Apple Watch Series 6 (GPS + Cellular, 40mm) - Product(RED) - Aluminium Case with Product(RED) - Sport Band",
	image: "https://m.media-amazon.com/images/I/81xjdZjthHL._SL1500_.jpg",
	price: "40,162.00",
	rating: "5",
};
const productH = {
	title:
		"Skullcandy Indy Evo True Wireless Earbuds with 30 Hours Total Battery+Rapid Charge, IP 55 Sweat, Water and Dust Resistant, Solo Bud and Tile Tracking (Black)",
	image:
		"https://images-na.ssl-images-amazon.com/images/I/71ZIpEqxYFL._SL1500_.jpg",
	price: "6,190.00",
	rating: "3",
};
const productI = {
	title: "Xbox Wireless Controller – Daystrike Camo Special Edition",
	image:
		"https://images-na.ssl-images-amazon.com/images/I/61afRwuIpaS._SL1500_.jpg",
	price: "6,290.00",
	rating: "5",
};
const productJ = {
	title:
		"DJI OSMO Action Camera (Silver,Grey) | Dual Screen | 12 MP Camera | 4K Recording Upto 60 FPS | Fast Mode Upto 240 FPS | HDR Recording",
	image:
		"https://images-na.ssl-images-amazon.com/images/I/61HT%2BjC-IWL._SL1000_.jpg",
	price: "18,990.00",
	rating: "5",
};
const productK = {
	title:
		"DJI Mavic Mini Nano Drone (Grey) | 12MP Camera | 2.7K Video Recording | Up to 30 mins of Flight time",
	image:
		"https://images-na.ssl-images-amazon.com/images/I/61cVgYqcJnL._SL1500_.jpg",
	price: "70,990.00",
	rating: "4",
};
const Home = () => {
	const [products, setProducts] = useState([]);

	useEffect(() => {
		// this code fires, when app loads
		db.collection("products").onSnapshot((shapshot) => {
			setProducts(shapshot.docs.map((doc) => doc.data()));
		});
	}, []);
	console.log(products);

	return (
		<div className="home">
			<div className="home__container">
				<div className="home__row">
					<Product product={productA} />
					<Product product={productB} />
				</div>
				<div className="home__row">
					<Product product={productG} />
					<Product product={productH} />
					<Product product={productI} />
				</div>
				<div className="home__row">
					<Product product={productJ} />
					<Product product={productK} />
				</div>
				<div className="home__row">
					<Product product={productC} />
					<Product product={productD} />
					<Product product={productE} />
				</div>
				<div className="home__row">
					<Product product={productF} />
				</div>
				<div className="home__rowNewProducts">
					{products.map((prods) => (
						<Product className="newProduct__grid" product={prods} />
					))}
				</div>
			</div>
		</div>
	);
};

export default Home;

/*
	const prodCollection = [];

	db.collection("products")
		.get()
		.then((querySnapshot) => {
			const documents = querySnapshot.docs.map((doc) => doc.data());
			// do something with documents
			console.log(documents);
			prodCollection.push(documents);
		});

	console.log(prodCollection);
*/
